import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { usePreAuthFinePrint } from 'reservations/account/providers/ConfigProvider';
import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { useLoadingSpinner } from 'reservations/base/providers/LoadingSpinnerProvider';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { useEnrollChecklessMutation } from 'reservations/checklessPayments/queries/useEnrollChecklessMutation';
import { PaymentForm } from 'reservations/payments/components/PaymentForm';

export const UpdateCardModalV2 = () => {
  const [handleSaveCard, setHandleSaveCard] = useState<() => void>(() => {});
  const { handleSubmit } = useFormContext();
  const { open, close, setModalContext } = useModal();
  const enrollChecklessMutation = useEnrollChecklessMutation(close, () =>
    setModalContext({ cardDeclinedError: true })
  );
  const { handleIsLoading } = useLoadingSpinner();

  const handleClick = async () => {
    handleIsLoading('Saving your payment method');
    await handleSaveCard?.();
    handleSubmit((data: Record<string, any>) =>
      enrollChecklessMutation.mutate(data)
    )();
  };

  return (
    <BaseDrawer
      header="Payment method"
      primaryButton={{ onClick: handleClick }}
      secondaryButton={{
        label: 'REMOVE CARD',
        variant: 'error',
        onClick: () => open(ModalType.RemoveCard)
      }}
      footer={usePreAuthFinePrint()}
      requireAuth
    >
      <PaymentForm setHandleSaveCard={setHandleSaveCard} />
    </BaseDrawer>
  );
};
